/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useState } from 'react';
import Model from '@tripian/model';
import { ChevronDown, Globe } from '../Svg/Icons';

interface ILanguageSelection {
  languageOptions?: Model.LangCode[];
  selectedLanguage: string;
  onSelectedLanguage: (value: string) => void;
}

const LanguageSelection: React.FC<ILanguageSelection> = ({ languageOptions, selectedLanguage, onSelectedLanguage }) => {
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedLanguageLabel = languageOptions?.find((language) => language.value === selectedLanguage)?.label;

  return (
    <div className="relative z-10" ref={dropdownRef}>
      <button type="button" onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)} className="flex w-full items-center gap-2 bg-white text-gray-500 px-4 py-2.5 transition-all duration-200 border border-gray-100 min-w-[100px]">
        <Globe />
        <span className="font-medium">{selectedLanguageLabel}</span>
        <ChevronDown size="1rem" className={`transform transition-transform duration-200 ${isLanguageDropdownOpen ? 'rotate-180' : ''}`} />
      </button>

      {isLanguageDropdownOpen && languageOptions && (
        <div className="absolute top-full left-4 mt-2 w-60 bg-white rounded-3xl shadow-xl border border-gray-100 z-50">
          {languageOptions.map((language, index) => (
            <button
              type="button"
              key={language.value}
              onClick={() => {
                onSelectedLanguage(language.value);
                setIsLanguageDropdownOpen(false);
              }}
              className={`w-full text-left px-4 py-2.5 hover:bg-primary-color-50 transition-colors duration-150 flex items-center justify-between
                      ${selectedLanguage === language.value ? 'bg-primary-color-50 text-primary-color' : 'text-gray-700'}
                      ${index === 0 ? 'rounded-t-3xl' : ''}
                      ${index === languageOptions.length - 1 ? 'rounded-b-3xl' : ''}`}
            >
              <span className="font-medium">{language.label}</span>
              <span className="text-sm text-gray-500">{language.value.toLocaleUpperCase()}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelection;
